import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { BookOpen } from 'lucide-react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { notiApi } from '../../lib/api-noti'

// Docs tab: the integration handbook served by the Go service itself
// (GET /v1/docs) — what other teams read before calling us.
export function DocsView() {
  const [slug, setSlug] = useState<string | null>(null)

  const index = useQuery({ queryKey: ['noti', 'docs'], queryFn: () => notiApi.docsIndex() })
  const active = slug ?? index.data?.data[0]?.slug ?? null
  const page = useQuery({
    queryKey: ['noti', 'docs', active],
    queryFn: () => notiApi.docContent(active!),
    enabled: !!active,
  })

  if (index.isLoading) return <div className="panel muted">โหลดสารบัญ…</div>
  if (index.isError) return <div className="panel error">{(index.error as Error).message}</div>

  return (
    <div className="docs-grid">
      <nav className="panel docs-nav" aria-label="สารบัญคู่มือ">
        <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
          <BookOpen size={16} aria-hidden /> คู่มือ
        </h3>
        <ul>
          {index.data?.data.map((p) => (
            <li key={p.slug}>
              <button
                className={`docs-link ${p.slug === active ? 'on' : ''}`}
                onClick={() => setSlug(p.slug)}
              >
                {p.title}
              </button>
            </li>
          ))}
        </ul>
      </nav>
      <article className="panel docs-body">
        {page.isLoading ? (
          <div className="muted">โหลดเนื้อหา…</div>
        ) : page.isError ? (
          <div className="error">{(page.error as Error).message}</div>
        ) : page.data ? (
          <div className="markdown">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{page.data.markdown}</ReactMarkdown>
          </div>
        ) : null}
      </article>
    </div>
  )
}
